/**
 * OrbDocCoreConceptsStandardLibrarySLOrbDocCoreConceptsStandardLibrarySLPage
 *
 * Page component for OrbDocCoreConceptsStandardLibrarySLOrbDocCoreConceptsStandardLibrarySLPage
 * Path: /sl/docs/core-concepts/standard-library
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsStandardLibrarySLDocScreenView as __OrbDocCoreConceptsStandardLibrarySLDocScreenView } from '@/components/traits/OrbDocCoreConceptsStandardLibrarySLDocScreenView';
import { OrbDocCoreConceptsStandardLibrarySLDocAnalyticsView as __OrbDocCoreConceptsStandardLibrarySLDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsStandardLibrarySLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsStandardLibrarySLOrbDocCoreConceptsStandardLibrarySLPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsStandardLibrarySLOrbDocCoreConceptsStandardLibrarySLPage(_props: OrbDocCoreConceptsStandardLibrarySLOrbDocCoreConceptsStandardLibrarySLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Standardna knjižnica","description":"Na stotine vedenj, od seznamov in obrazcev do iger in učnih pripomočkov, pripravljenih za uvoz in vezavo.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/standard-library"},{"locale":"ar","path":"/ar/docs/core-concepts/standard-library"},{"locale":"sl","path":"/sl/docs/core-concepts/standard-library"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsStandardLibrarySLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsStandardLibrarySLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCoreConceptsStandardLibrarySLOrbDocCoreConceptsStandardLibrarySLPage;
